// extracted by mini-css-extract-plugin
export default {"container":"StatHttpMonitorHeader_container__8UKrZ","item":"StatHttpMonitorHeader_item__Ns9oj","green":"StatHttpMonitorHeader_green__oVG-l","red":"StatHttpMonitorHeader_red__FN2XV"};